module.exports = function() {
  return new Worker(__webpack_public_path__ + "2f824afd46df8a83cbc6.worker.js");
};